module.exports = __webpack_public_path__ + "img/mingzhi_icon_03.dec2aa8b.png";